import multiFileToolbarTemplate from './multi-file-toolbar.tpl.html';
import './multi-file-toolbar.less';
import { fileIconComponentModule } from '../file-icon/file-icon';

export const multiFileToolbarComponentModule = angular
  .module('Q.components.multi-file-toolbar', [fileIconComponentModule])

  .component('multiFileToolbar', {
    bindings: {
      actions: '<',
      onClick: '&',
    },
    controller: 'MultiFileToolbarCtrl',
    template: multiFileToolbarTemplate,
  })

  .controller('MultiFileToolbarCtrl', function MultiFileToolbarCtrl() {
    const ctrl = this;

    ctrl.click = (action) => {
      if (action.onToolbarClick) {
        action.onToolbarClick();
      } else {
        ctrl.onClick({ action });
      }
    };
  });
